import React, { useState, useEffect, useMemo } from 'react'
import _ from 'lodash'
import { Modal, Form, Input, Header, Divider, Button, Confirm , Label, Icon} from 'semantic-ui-react'
import PropTypes from "prop-types";
import { GetHotelParameters } from '../../api/services/organization';
import { UpdateYields } from '../../api/services/pms';
import qs from 'querystringify'
import { onSuccess, onError, onWarning } from '../shared/messages'
import WeekDaysSelect from '../shared/WeekDaysSelect'
import {DatePicker} from '../shared/DatePicker';
import  {useTextResources,useMessageResources} from '../../language';
import { isMobileOnly} from 'mobile-device-detect';
import moment from 'moment';
import Slider from '../shared/Slider'
import { useLoader } from '../shared/utils';
import { dateFormat } from '../shared/constants';

const YieldPopup = ({ HotelID, onClose, controller,startOpen,  ...rest }) => {
    const text = useTextResources()
    const message = useMessageResources()
    const loader = useLoader()
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    // dates[0] - startDate, dates[1] - endDate
    const [dates, setDates] = useState([new Date(), new Date()])
    const [open, setOpen] = useState(startOpen);
    const [days, setDays] = useState(null);
    const [yieldLevel, setYieldLevel] = useState(0);
    const [isSaving, setIsSaving] = useState(false);
    const [params, setParams] = useState(null);
    const [saveYieldPopupActive, setSaveYieldPopupActive] = useState(false);
    const [closeAfterSave, setCloseAfterSave] = useState(false);
    const [currentBusinessDate, setCurrentBusinessDate] = useState(new Date());
    const [selectedDates, setSelectedDates] = useState([])

    const updatePopupData = async () => {
        try {
            (async () => {
                const query = qs.parse(location.search)
                const hotelID = query.HotelId || query.hotelId || HotelID
                const hotelParams = await GetHotelParameters({ ID: hotelID })
                let hotels = hotelParams.CurrentHotel
                if (hotels && hotels.length) {
                    setCurrentBusinessDate(new Date(hotels[0].HotelParameter.CurrentBusinessDate))
                    resetFields()
                }
            })()
        } catch (error) {
            console.error(error)
            error.status === 400 ? onWarning(error) : onError(error)
        }
    }

    const updateStartDate = (startDate)=>{
        let tempDatesState = dates.slice()
        tempDatesState[0] = startDate
        setDates(tempDatesState)
    }
    const updateEndDate = (endDate)=>{
        let tempDatesState = dates.slice()
        tempDatesState[1] = endDate
        setDates(tempDatesState)
    }

    useEffect(()=>{
        if (controller){
            window[controller] = async (action, params)=>{
                switch (action) {
                    case "open":
                        if (params) {
                            setParams(params)
                            updateStartDate(params.StartDate || new Date())
                            updateEndDate(params.EndDate || new Date())
                        }
                        else{
                            await updatePopupData()
                        }
                        setOpen(true)
                        break;
                    default:
                        break;
                }
            }
        }
    },[])

    useEffect(() => {
        updatePopupData()
    }, [])

    useEffect(()=>{
        if (dates[1]&& moment(dates[1]).isSameOrBefore(moment(dates[0]))){
            updateEndDate(dates[0])
        }
    }, [dates[0]])

    const updateYields = async (removeExceptionsInDateRange) => {
        try {
            setIsSaving(true);
            setSaveYieldPopupActive(false);
            if(closeAfterSave){
                closeAction();
            }
            loader(true)
            let weekDays = [0,1,2,3,4,5,6];
            let yieldDays = [];
            weekDays.forEach(wDay => {
                if(days.includes(wDay))
                    {
                        yieldDays.push(true)
                    }
                else{
                    yieldDays.push(false);
                }
            });
            const thedays = _.reduce(yieldDays, (val, day, index) => {
                return val + (day ? String(index + 1) : "")
            }, "")
            const query = qs.parse(location.search)
            const hotelID = query.HotelId || query.hotelId || HotelID
            if(selectedDates.length>0){
                for(let index = 0; index< selectedDates.length; index++){
                    await UpdateYields({
                        StartDate: selectedDates[index].startDate,
                        EndDate: selectedDates[index].endDate,
                        HotelId: hotelID,
                        Level: yieldLevel,
                        Days: thedays,
                        RemoveExceptionsInDateRange: removeExceptionsInDateRange
                    })
                }
        }else{
            await UpdateYields({
                StartDate: dates[0],
                EndDate: dates[1],
                HotelId: hotelID,
                Level: yieldLevel,
                Days: thedays,
                RemoveExceptionsInDateRange: removeExceptionsInDateRange
            })
        }
            if (params && params.OnSave) {
                params.OnSave();
            }
            setIsSaving(false);
            loader(false)
            onSuccess()
        } catch (error) {
            console.error(error)
            error.status === 400 ? onWarning(error) : onError(error)
        }
        loader(false)
        setIsSaving(false);
    }

    const closeAction = () => {
        setOpen(false)
        resetFields()
        if (onClose) onClose()
    }
    
    const addDateToList = () =>{
        if(selectedDates.some((d)=> moment(d.startDate).isSame(dates[0], 'day') && moment(d.endDate).isSame(dates[1], 'day'))) 
        {
            onWarning(text('WarningDuplicateDates'))
            return
        }

        setSelectedDates(selectedDates=> selectedDates.concat(
            {startDate: dates[0],
             endDate: dates[1]}))
    }

    const handleDatesChanged= (newValue)=>{
        if(newValue){
            setDates(newValue)
        } else {
            setDates([currentBusinessDate,currentBusinessDate])
        }
    }

    const onRemoveDateFromSelectedDates = async (index,e)=>{
        if(e){
            await setSelectedDates(selectedDates=> selectedDates.filter((_,i)=>i !== index))
        }
    }

    const resetFields= async ()=>{
        setYieldLevel('0');
        await setSelectedDates([])
        await setDates([currentBusinessDate,currentBusinessDate])
    }

    const memoDates = useMemo(()=>{
        return selectedDates.length?selectedDates:[{startDate: dates[0], endDate: dates[1]}]
      }, [dates, selectedDates])

    return (
        <Modal size={isMobileOnly?"fullscreen":"tiny"} open={open} className={isMobileOnly?"mobile":""} style={{zIndex: 1000000}} {...rest} >
            {!isMobileOnly && <Modal.Header>{text("YieldUpdate")}</Modal.Header>}
            <Modal.Content>
                <Form unstackable>
                    <Header style={{ color: "#4f849e" }}>{text('YieldLevelApplies')}</Header>
                    <Form.Group unstackable widths={'equal'} style={{flexWrap: "wrap"}}>
                        {selectedDates.map((selectedDate, index)=>(
                            <Label.Group key={index}>
                                <Label>
                                    {moment(selectedDate.startDate).format(dateFormat)}
                                    - 
                                    {moment(selectedDate.endDate).format(dateFormat)}
                                    <Icon key={index} name={"delete"}  onClick={onRemoveDateFromSelectedDates.bind(this,index)}/>
                                </Label>
                            </Label.Group>
                        ))}
                    </Form.Group>
                    <Form.Group unstackable style={{alignItems: "flex-end"}}>
                        <Form.Field width={12} style={{display: "grid"}}>
                            <DatePicker
                                type="range"
                                onChange={handleDatesChanged}
                                label={text("DateRange")}
                                value={dates}
                                minDate={moment(currentBusinessDate).startOf("day").toDate()}   
                                />
                             </Form.Field>
                    <Form.Field widths={4}>
                    <Button style={{position: "relative", marginTop: "22%"}}
                            primary 
                            size="small"
                            onClick={addDateToList}>
                                {text("AddDate")}
                    </Button>
                    </Form.Field>
                </Form.Group>
                    <Divider hidden/>
                    <Form.Field label={text("Weekdays")} control={WeekDaysSelect} onChange={setDays} dates={memoDates}/>
                    <div className="field" style={{ marginTop: "10px" }}>
                        <label>{text("YieldLevels")}</label>
                        <Input value={yieldLevel} type="number" min={0} max={100}
                            onChange={(e, data) => {
                                setYieldLevel(data.value);
                            }} action>
                            <input />
                            <div className="ui selection dropdown" style={{ padding: "0.78em", width: "100%" }}>
                                <Slider
                                    value={yieldLevel} color="blue"
                                    settings={{
                                        start: 0,
                                        min: 0,
                                        max: 100,
                                        step: 1,
                                        onChange: value => {
                                            setYieldLevel(value);
                                        }
                                    }}
                                />
                            </div>
                        </Input>
                    </div>
                </Form>
                <Confirm
                    dimmer="inverted"
                    open={saveYieldPopupActive}
                    header={text("Yield")}
                    content={message("ConfirmationRecalculateManuallyOverridenPrices")}
                    confirmButton={{ content: text("Yes"), loading: isSaving}}
                    cancelButton={{content: text("No"), loading: isSaving}}
                    onCancel={() => updateYields(false)}
                    onConfirm={() => updateYields(true)}
                />
            </Modal.Content>
            <Modal.Actions>
                {!isMobileOnly&&<Button size={"small"} negative onClick={closeAction}>{text("Close")}</Button>} 
                {!isMobileOnly&&<Button size={"small"} onClick={resetFields}>{text("Reset")}</Button>}
                {!isMobileOnly&&<Button size={"small"} loading={isSaving} positive onClick={()=> {setSaveYieldPopupActive(true); setCloseAfterSave(true);}}>{text("Saveandclose")}</Button>}
                <Button size={"small"} loading={isSaving} positive onClick={()=>setSaveYieldPopupActive(true)}>{text("Save")}</Button>
            </Modal.Actions>
        </Modal>
    )
}
YieldPopup.propTypes = {
    HotelID: PropTypes.number,
    onClose: PropTypes.func,
    controller: PropTypes.string,
    startOpen: PropTypes.bool
}

export default YieldPopup